import { useMutation } from '@tanstack/react-query';

interface PostOrganizationTutorialsResponse {
  success: boolean;
}

export default function usePostOrganizationTutorials() {
  return useMutation({
    mutationFn: async (tutorialTypes: string[]) => {
      const response = await fetch('/agent/api/organization_tutorials', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({ tutorial_type: tutorialTypes }),
      });

      if (!response.ok) {
        throw new Error('Failed to create tutorials');
      }

      const data: PostOrganizationTutorialsResponse = await response.json();
      return data;
    },
  });
}
